import { render, staticRenderFns } from "./HeroMetricDescription.vue?vue&type=template&id=2f5b8195&scoped=true"
import script from "./HeroMetricDescription.vue?vue&type=script&lang=js"
export * from "./HeroMetricDescription.vue?vue&type=script&lang=js"
import style0 from "./HeroMetricDescription.vue?vue&type=style&index=0&id=2f5b8195&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b8195",
  null
  
)

export default component.exports